<template>
    <b-row class="w-100 pt-md-1" no-gutters>
        <b-col cols="2" class="d-flex justify-content-center align-items-start">
            <b-img
                    v-if="isUser"
                    :src="userAvatar"
                    :height="25"
                    :width="25"
                    fluid
            />
            <b-img
                    v-else
                    :height="25"
                    :width="25"
                    :src="`static/img/icons/timeline/${todo.icon}`"
                    @error="$event.target.src = '/static/img/activities/white/default.png'"
            />
        </b-col>
        <b-col cols="10" v-if="isTwoColumn">
            <h6 class="text-primary my-0 font-weight-bold">{{todo.title}}</h6>
            <chart-bar
                    v-if="todo.type === 'statistiques_meetings_by_day'"
                    :chart-data="meetingByDay"
                    :options="barChartOptions"
                    :width="300"
                    :height="100"
                    class="coach-todo--chart"
            />
            <b-btn variant="link" size="sm" :to="todo.link" class="mx-0 px-0">{{todo.linkText}}</b-btn>
        </b-col>
        <template v-else>
            <b-col cols="8" class="d-flex flex-column justify-content-start align-items-start">
                <h6 class="text-primary my-0 font-weight-bold">{{todo.title}}</h6>
                <small class="text-muted">{{todo.ou}}</small>
                <small>{{todo.subtitle}}</small>
                <p class="my-0">{{todo.text}}</p>
                <b-btn
                        v-if="todo.type !== 'statistiques_taux_participation'"
                        variant="link"
                        size="sm"
                        :to="todo.link"
                        class="mx-0 px-0"
                >
                    {{todo.linkText}}
                </b-btn>
            </b-col>
            <b-col cols="2" class="d-flex justify-content-center align-items-center">
                <b-progress
                        v-if="isCampaign"
                        :value="todo.element['num_done']"
                        :max="todo.element['num_targets']"
                        animated
                        style="width:50px;height:1.25em;"
                />
                <i
                        v-else-if="isUser"
                        class="fas fa-birthday-cake fa-3x text-primary"
                />
                <i
                        v-else-if="isStats"
                        class="fas fa-3x"
                        :class="[
                                todo.element.trend === 'up' ? 'fa-arrow-up text-success':'',
                                todo.element.trend === 'equal' ? 'fa-equals text-muted':'',
                                todo.element.trend === 'down' ? 'fa-arrow-down text-danger':'',
                        ]"
                />
            </b-col>
        </template>
    </b-row>
</template>
<style lang="scss" scoped>
    .progress {
        transform: rotate(-90deg);
    }

    .coach-todo--chart {
        /*width: 100%;*/
        /*height: 100px;*/
    }
</style>
<script>
    import ChartBar from "./chart/BarChart";
    import moment from 'moment'
    import {layerColor} from '@/utils/ColorFactory';

    export default {
        name: 'coach-todo',
        components: {ChartBar},
        props: {
            todo: Object
        },
        mounted() {
            this.layerColor = layerColor(0.75)
        },
        data: () => ({
            moment,
            layerColor: null
        }),
        computed: {
            isTwoColumn() {
                return ['statistiques_meetings_by_day'].includes(this.todo.type)
            },
            isMeeting() {
                return this.todo.type.startsWith('meeting')
            },
            isCampaign() {
                return this.todo.type.startsWith('campaign')
            },
            isUser() {
                return this.todo.type.startsWith('user')
            },
            isStats() {
                return this.todo.type.startsWith('statistiques')
            },
            img() {
                if (this.isMeeting) {
                    return this.$store.getters['base/activity/getTypeActivityIcon'](this.todo.element.activite.typeactivite, 'blue')
                }
            },
            userAvatar() {
                return this.$store.getters['base/account/getAvatar'](this.todo.element)
            },
            meetingByDay() {
                const days = Object.keys(this.todo.element)
                const labels = []
                const datasets = [{
                    backgroundColor: this.layerColor,
                    data: [],
                    label: '',
                    type: 'bar',
                }]
                for (const day of days) {
                    labels.push(moment(day, 'DD/MM/YYYY').format('dd'))
                    datasets[0].data.push(this.todo.element[day])
                }
                return {labels, datasets}
            },
            barChartOptions() {
                return {
                    responsive: true,
                    tooltips: {
                        enabled: false
                    },
                    legend: {
                        display: false
                    },
                    layout: {
                        padding: {
                            top: 25
                        }
                    },
                    plugins: {
                        labels: {
                            render: args => '',
                            showZero: false,
                            textMargin: 10
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                scaleSteps: 1,
                                beginAtZero: true,
                                userCallback: (label) => {
                                    if (Math.floor(label) === label) {
                                        return label;
                                    }
                                }
                            }
                        }]
                    }
                }
            }
        }
    }
</script>
